import packageInfo from '../../package.json';

export const getVersion = (): string => {
  return packageInfo.version || '0.1.0';
};

export const formatVersion = (): string => {
  return `v${getVersion()}`;
};
